import { render } from "./Button.vue.ts?vue&type=template&id=1a223a5b&scoped=true&ts=true!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./Button.vue?vue&type=template&id=1a223a5b&scoped=true&ts=true"
import script from "./Button.vue.ts?vue&type=script&lang=ts!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./Button.vue?vue&type=script&lang=ts"
export * from "./Button.vue.ts?vue&type=script&lang=ts!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./Button.vue?vue&type=script&lang=ts"

import "./Button.vue.scss?vue&type=style&index=0&id=1a223a5b&lang=scss&scoped=true!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./Button.vue?vue&type=style&index=0&id=1a223a5b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a223a5b"],['__file',"src/apps/core-app-onboarding/components/Button.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1a223a5b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1a223a5b', __exports__)) {
    api.reload('1a223a5b', __exports__)
  }
  
  module.hot.accept("./Button.vue.ts?vue&type=template&id=1a223a5b&scoped=true&ts=true!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./Button.vue?vue&type=template&id=1a223a5b&scoped=true&ts=true", () => {
    api.rerender('1a223a5b', render)
  })

}


export default __exports__